module.exports = __webpack_public_path__ + "img/sharp-example13.ec8b448b.jpg";